<template>
  <select
    type="text"
    :name="selectName"
    :id="selectId"
    :class="selectClasses.join(' ')"
    placeholder="Mon,Wed,Fri"
    :multiple="multiple"
  >
    <option
      value=""
    >
      {{ spacerOption }}
    </option>
    <option
      v-for="wday, i in wdays"
      :value="wday.toLowerCase()"
      :selected="isSelected(i)"
    >
      {{ wday }}
    </option>
  </select>
</template>
<script>
export default {
  computed: {
    wdays: () => {
      return [
        'Sunday', 'Monday', 'Tuesday',
        'Wednesday', 'Thursday', 'Friday',
        'Saturday'
      ]
    }
  },

  props: {
    selectName: {
      type: String,
      default: 'weekday'
    },

    id: {
      type: String,
      default: 'select-weekday'
    },

    selectClasses: {
      type: Array,
      default: [ 'form-control' ]
    },

    spacerOption: {
      type: String,
      default: 'Select a Weekday'
    },

    // 0-6, where 0 is a Sunday and 6 is Saturday.
    selected: {
      type: Number
    },

    multiple: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    isSelected (val) {
      return this.selected === val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/utils/WeekdaySelect.vue